// extracted by mini-css-extract-plugin
export var orderDetails = "_q6-2";
export var orderImage = "_q6-1";
export var orderMeta = "_q6-3";
export var orderSummary = "_q6-0";
export var rightArrow = "_q6-4";